import { CustomTextField } from '@components/Styles/CommonStyle';

const defaultProps = {
  type: 'text', // 입력 필드 타입 (text, password, number 등)
  required: false, // 필수 입력 여부
  disabled: false, // 비활성화 여부
  fullWidth: true, // 너비 100% 사용
  size: 'medium', // 입력 필드 크기 (small, medium)
  variant: 'outlined', // 입력 필드 스타일 (outlined, filled, standard)
  multiline: false, // 여러 줄 입력 가능 여부
};

const CustomInput = (props) => <CustomTextField {...defaultProps} {...props} />;

export default CustomInput;
